
import propsForMixin from '../../mixins/props-for';
import { objectToSortedArray } from '../../utils';

import Card from './Card';

export default {
  components: {
    Card,
  },

  mixins: [propsForMixin],

  props: {
    id: { type: String, default: '' },
    subNodes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isCarouselMounted: false,
      currentSlide: 0,
    };
  },

  computed: {
    subNodesArray() {
      return objectToSortedArray(this.subNodes);
    },

    showCarousel() {
      return this.subNodesArray?.length > 2;
    },

    showScrollbar() {
      if (!this.isCarouselMounted) {
        return false;
      }

      return this.$refs.carousel?.classes?.['v-slide-group--is-overflowing'];
    },

    scrollThumbStyling() {
      if (!this.isCarouselMounted) {
        return {};
      }

      const { carousel } = this.$refs;
      const { content, wrapper } = carousel.widths;
      const width = (100 / content) * wrapper;

      return {
        width: `${width}%`,
        left: `${Math.min(100 - width, (100 / content) * carousel.scrollOffset)}%`,
      };
    },
  },

  methods: {
    onClickNext() {
      this.currentSlide += 1;
    },

    onClickPrev() {
      this.currentSlide -= 1;
    },

    onCarouselMounted() {
      this.isCarouselMounted = true;
    },
  },
};
